import React, { useEffect, useState } from "react";

import MobileVideoSlider from "./mobile-video-slider";
import DesktopVideoSlider from "./desktop-video-slider";

const VideoCardSlider = ({ collection }) => {
  const [stories, setStories] = useState([]);
  const [isMobile, setMobile] = useState(false);

  if (!(collection && collection.items)) return null;
  const VideosCollections = collection?.items.filter((item) => item.type === "collection");
  const allStories = collection?.items[0]?.items?.filter((item) => item.type === "story").map((item) => item.story);

  if (!(allStories && collection?.items[0].type == "collection")) return null;

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  const selectItem = (item, id) => {
    setStories(collection.items[id].items?.filter((item) => item.type === "story").map((item) => item.story));
  };

  return isMobile ? (
    <MobileVideoSlider
      allStories={stories.length > 1 ? stories : allStories}
      collection={collection}
      selectItem={selectItem}
      VideosCollections={VideosCollections}
    />
  ) : (
    <DesktopVideoSlider
      allStories={stories.length > 1 ? stories : allStories}
      collection={collection}
      selectItem={selectItem}
      VideosCollections={VideosCollections}
    />
  );
};

export default VideoCardSlider;
